import http from "@seims/shared/src/services/HttpService";
import local from '../data/eventsStatus'

var endpoint = `/lookup/event/`;


const getEventStatus = async () => {
    const response = await http.get(`${endpoint}status`);
    return response;
  };
  const getEventsByStatus =  (statusKey) => {
    const response =  local.listDetails.filter(event => event.statusId === statusKey);
    return response;
  };

  // eslint-disable-next-line import/no-anonymous-default-export
  export default  { 
    getEventStatus,
    getEventsByStatus
  };